﻿"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const app_commons_1 = require("@its-suite/app-commons");
const operational_context_client_1 = require("@its-suite/operational-context-client");
const redux_1 = require("../../redux");
class AuthRouteInternal extends React.Component {
    render() {
        let content = null;
        let jwtManager = new operational_context_client_1.JwtManager();
        if (jwtManager.validateToken()) {
            if (this.props.hasPermissions) {
                const _a = this.props, { component, path, exact, permissions, hasPermissions } = _a, rest = __rest(_a, ["component", "path", "exact", "permissions", "hasPermissions"]);
                content = React.createElement(react_router_1.Route, Object.assign({ exact: true, path: path, component: component }, rest));
            }
            else {
                content = React.createElement(react_router_1.Redirect, { to: app_commons_1.ApplicationRoutes.INVALID_PERMISSIONS, push: true });
            }
        }
        else {
            window.location.assign(app_commons_1.UrlHelper.getBaseAppUrl(process.env.APP_NAME));
        }
        return content;
    }
}
function mapStateToProps(state, props) {
    return {
        hasPermissions: redux_1.SessionSelector.hasPermissions(props.permissions)(state)
    };
}
exports.AuthRoute = react_redux_1.connect(mapStateToProps)(AuthRouteInternal);
//# sourceMappingURL=AuthRoute.js.map